import { render, staticRenderFns } from "./DoctorDetailsCard.vue?vue&type=template&id=b2e7a7e4&"
import script from "./DoctorDetailsCard.vue?vue&type=script&lang=js&"
export * from "./DoctorDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports